import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var pluginKey = new PluginKey('undoRedoPlugin');